import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from 'react';
import { useId, useRef, useState } from 'react';
import { createShareUrl } from '#cutils/shareurls/createShareUrl';
import { IconSystem } from '#icons/IconSystem';
import styles from './SocialMediaPopover.module.scss';
import { createShareText } from './SocialMediaPopover.utils';
import { IconSystemLink } from './base/IconButton/IconSystemLink';
import { Tooltip } from './base/Tooltip/Tooltip';
type Props = {
  headline?: string | null;
  url: string;
  onClose?: () => void;
  position: 'left' | 'right' | 'top' | 'bottom' | undefined;
  arrowPositionLeft: number;
  arrowPositionTop: number;
};
export function SocialMediaPopover(t0) {
  const $ = _c(68);
  const {
    headline,
    url,
    onClose,
    position,
    arrowPositionLeft,
    arrowPositionTop
  } = t0;
  let t1;
  if ($[0] !== headline || $[1] !== url) {
    t1 = createShareUrl("facebook", createShareText("facebook", headline), "Facebook", url);
    $[0] = headline;
    $[1] = url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const facebookShareUrl = t1;
  let t2;
  if ($[3] !== headline || $[4] !== url) {
    t2 = createShareUrl("twitter", createShareText("twitter", headline), "Twitter", url);
    $[3] = headline;
    $[4] = url;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const twitterShareUrl = t2;
  let t3;
  if ($[6] !== headline || $[7] !== url) {
    t3 = createShareUrl("whatsapp", createShareText("whatsapp", headline), "WhatsApp", url);
    $[6] = headline;
    $[7] = url;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const whatsAppShareUrl = t3;
  let t4;
  if ($[9] !== url) {
    t4 = createShareUrl("url", "", "Link", url);
    $[9] = url;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const normalShareUrl = t4;
  const [copySuccess, setCopySuccess] = useState(false);
  const urlObjectRef = useRef(null);
  const copyLinkLabelId = useId();
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = function copyToClipboard() {
      const urlToCopy = urlObjectRef?.current?.value;
      if (urlToCopy) {
        navigator.clipboard.writeText(urlToCopy);
        setCopySuccess(true);
      }
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const copyToClipboard = t5;
  const positionClass = position ? styles[position] : "";
  let arrowStyle;
  bb0: switch (position) {
    case "bottom":
      {
        let t6;
        if ($[12] !== arrowPositionLeft) {
          t6 = {
            left: arrowPositionLeft,
            top: 0
          };
          $[12] = arrowPositionLeft;
          $[13] = t6;
        } else {
          t6 = $[13];
        }
        arrowStyle = t6;
        break bb0;
      }
    case "top":
      {
        let t6;
        if ($[14] !== arrowPositionLeft) {
          t6 = {
            left: arrowPositionLeft,
            bottom: 0
          };
          $[14] = arrowPositionLeft;
          $[15] = t6;
        } else {
          t6 = $[15];
        }
        arrowStyle = t6;
        break bb0;
      }
    case "right":
      {
        let t6;
        if ($[16] !== arrowPositionTop) {
          t6 = {
            top: arrowPositionTop,
            left: 0
          };
          $[16] = arrowPositionTop;
          $[17] = t6;
        } else {
          t6 = $[17];
        }
        arrowStyle = t6;
        break bb0;
      }
    case "left":
      {
        let t6;
        if ($[18] !== arrowPositionTop) {
          t6 = {
            top: arrowPositionTop,
            right: 0
          };
          $[18] = arrowPositionTop;
          $[19] = t6;
        } else {
          t6 = $[19];
        }
        arrowStyle = t6;
        break bb0;
      }
    default:
      {
        arrowStyle = undefined;
      }
  }
  const t6 = `${styles.popOverWrapper} ${positionClass ?? ""}`;
  let t7;
  if ($[20] !== arrowStyle) {
    t7 = <div className={`${styles.arrow}`} style={arrowStyle} />;
    $[20] = arrowStyle;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span>Teilen auf:</span>;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== onClose) {
    t9 = () => onClose?.();
    $[23] = onClose;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconSystem icon="close" variant="filled" role="button" />;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t9) {
    t11 = <div className={`${styles.popOverHeader} heading4`}>{t8}<button className={`${styles.actionButton} button-link`} onClick={t9} title={"Schlie\xDFen"}>{t10}</button></div>;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== twitterShareUrl) {
    t12 = <IconSystemLink type="tertiary" icon="twitter-x" variant="filled" role="button" target="_blank" href={twitterShareUrl} />;
    $[28] = twitterShareUrl;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== facebookShareUrl) {
    t13 = <IconSystemLink type="tertiary" icon="facebook" variant="filled" role="button" target="_blank" href={facebookShareUrl} />;
    $[30] = facebookShareUrl;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== whatsAppShareUrl) {
    t14 = <IconSystemLink type="tertiary" icon="whatsapp" variant="filled" role="button" target="_blank" href={whatsAppShareUrl} />;
    $[32] = whatsAppShareUrl;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t12 || $[35] !== t13 || $[36] !== t14) {
    t15 = <div className={styles.socialMediaIcons}>{t12}{t13}{t14}</div>;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== copyLinkLabelId) {
    t16 = <span id={copyLinkLabelId}>Link kopieren:</span>;
    $[38] = copyLinkLabelId;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== copyLinkLabelId) {
    t17 = <IconSystem icon="link" variant="filled" size="s" aria-labelledby={copyLinkLabelId} />;
    $[40] = copyLinkLabelId;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== copyLinkLabelId || $[43] !== normalShareUrl) {
    t18 = <input className={styles.url} disabled={true} type="text" name="url" defaultValue={normalShareUrl} ref={urlObjectRef} aria-labelledby={copyLinkLabelId} />;
    $[42] = copyLinkLabelId;
    $[43] = normalShareUrl;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t17 || $[46] !== t18) {
    t19 = <div className={styles.linkSharerWrapper}>{t17}{t18}</div>;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IconSystem icon="copy" variant="filled" role="button" />;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== copyLinkLabelId) {
    t21 = <button className={`${styles.actionButton} button-link`} onClick={copyToClipboard} aria-labelledby={copyLinkLabelId}>{t20}</button>;
    $[49] = copyLinkLabelId;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t19 || $[52] !== t21) {
    t22 = <div className={styles.copySection}>{t19}{t21}</div>;
    $[51] = t19;
    $[52] = t21;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t16 || $[55] !== t22) {
    t23 = <div className={styles.popOverFooter}>{t16}{t22}</div>;
    $[54] = t16;
    $[55] = t22;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== copySuccess) {
    t24 = copySuccess && <Tooltip type="success" content="Link kopiert" />;
    $[57] = copySuccess;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== t11 || $[60] !== t15 || $[61] !== t23 || $[62] !== t24) {
    t25 = <div className={`${styles.popOver} body3`}>{t11}{t15}{t23}{t24}</div>;
    $[59] = t11;
    $[60] = t15;
    $[61] = t23;
    $[62] = t24;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== t25 || $[65] !== t6 || $[66] !== t7) {
    t26 = <div className={t6} data-theme-area="dark">{t7}{t25}</div>;
    $[64] = t25;
    $[65] = t6;
    $[66] = t7;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  return t26;
}